import React, { useEffect, useState } from 'react';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import { Link } from 'react-router-dom';

import { obtenirDeploiements } from '../deploiements/deploiementApi';

function lireDate(rapport) {
  const valeur = (rapport && (rapport.dateRapport || rapport.createdAt || rapport.date)) || '';
  if (!valeur) return '-';
  const d = new Date(valeur);
  if (Number.isNaN(d.getTime())) return valeur;
  return d.toLocaleString();
}

function SitewebReportsList({ rafraichirDeclencheur }) {
  const [rapports, setRapports] = useState([]);
  const [chargement, setChargement] = useState(true);
  const [erreur, setErreur] = useState('');

  useEffect(() => {
    let actif = true;
    setChargement(true);
    setErreur('');
    obtenirDeploiements()
      .then((data) => {
        if (!actif) return;
        const liste = Array.isArray(data) ? data : [];
        setRapports(liste.filter((x) => x && x.type === 'deploiement_siteweb'));
      })
      .catch((err) => {
        if (!actif) return;
        setErreur(err.message || 'Impossible de charger les rapports siteweb.');
      })
      .finally(() => { if (actif) setChargement(false); });
    return () => { actif = false; };
  }, [rafraichirDeclencheur]);

  return (
    <Paper style={{ padding: 16 }}>
      <Typography variant="h6">Historique des rapports siteweb</Typography>
      {chargement && <div style={{ marginTop: 16 }}><CircularProgress size={24} /></div>}
      {erreur && <Typography color="error" style={{ marginTop: 16 }}>{erreur}</Typography>}
      {!chargement && !erreur && (
        <div style={{ marginTop: 12, overflowX: 'auto' }}>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Date</TableCell>
                <TableCell>Environnement</TableCell>
                <TableCell>Operateur</TableCell>
                <TableCell>Decision</TableCell>
                <TableCell align="right">Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rapports.map((rapport, i) => (
                <TableRow key={rapport._id || rapport.id || i}>
                  <TableCell>{lireDate(rapport)}</TableCell>
                  <TableCell>{rapport.environnementCible || '-'}</TableCell>
                  <TableCell>{rapport.operateur || '-'}</TableCell>
                  <TableCell>{rapport.decisionFinale || '-'}</TableCell>
                  <TableCell align="right">
                    <Button
                      component={Link}
                      to={'/Ingenierie/DeploiementsSiteweb/' + encodeURIComponent(rapport._id || rapport.id)}
                      color="primary"
                      variant="outlined"
                      size="small"
                      disabled={!rapport._id && !rapport.id}
                    >
                      Consulter
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
              {rapports.length === 0 && (
                <TableRow><TableCell colSpan={5}>Aucun rapport siteweb enregistre.</TableCell></TableRow>
              )}
            </TableBody>
          </Table>
        </div>
      )}
    </Paper>
  );
}

export default SitewebReportsList;



// WEBPACK FOOTER //
// src/components/deploiementsSiteweb/SitewebReportsList.js